export default [
  {
    label: 'Open',
    value: 'open',
  },
  {
    label: 'Paid',
    value: 'paid',
  },
];
